import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/recursos_humanos/colaborador';
import Colaborador from './ColaboradorList';


const ms2p = (state) => {
  return {
    ...state.colaborador,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Colaborador);
